import { useEffect, useState } from 'react';
import {
  isSmarPanelEnabled,
  SMARPANEL_FLAG_CHANGED_EVENT,
} from '../utils/smarPanelStorage';

export function useSmarPanelFlag() {
  const [enabled, setEnabled] = useState(() => isSmarPanelEnabled());

  useEffect(() => {
    function syncFlag() {
      setEnabled(isSmarPanelEnabled());
    }

    window.addEventListener(SMARPANEL_FLAG_CHANGED_EVENT, syncFlag);

    return () => {
      window.removeEventListener(SMARPANEL_FLAG_CHANGED_EVENT, syncFlag);
    };
  }, []);

  return enabled;
}
